module.exports = __webpack_public_path__ + "img/huiyuannianxian@2x.bfbd5327.png";